import React, { useState, useEffect, useContext } from 'react';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import '../ShipmentSelectScanType.css';
import { UserContext } from '../../common/UserContext';
import config from '../../../envconfig';
function ShipInScanSearch() {
    const { UM_GroupId, UM_CompanyGrpID, selectedScpId, UM_CompanyID, UM_UserId, UM_UserCode, UM_DefaultSCPId } = useContext(UserContext);

    useEffect(() => {
        sessionStorage.setItem('UM_GroupId', UM_GroupId);
        sessionStorage.setItem('UM_CompanyGrpID', UM_CompanyGrpID);
        sessionStorage.setItem('UM_DefaultSCPId', UM_DefaultSCPId);
        sessionStorage.setItem('UM_CompanyID', UM_CompanyID);
        sessionStorage.setItem('UM_UserId', UM_UserId);
        sessionStorage.setItem('UM_UserCode', UM_UserCode);
        sessionStorage.setItem('selectedScpId', selectedScpId);

    }, [UM_GroupId, UM_CompanyGrpID, UM_DefaultSCPId, UM_CompanyID, UM_UserId, UM_UserCode, selectedScpId]);
    const [userData, setUserdata] = useState([]);
    const [searchQuery, setSearchQuery] = useState('');

    //============================= Navigation ===================================
    const navigate = useNavigate();
    const [navigateTo, setNavigateTo] = useState('');
    //========= This handleRowClick is for redirect to shipment outward by product and vendor =======
    const handleRowClick = (shipment) => {
        if (shipment.SHPH_ByProductVendorScanMode === 1) {
            setNavigateTo(`/ShipInScanByVendor/${shipment.SHPH_ShipmentID}`);
        }
        if (shipment.SHPH_ByProductVendorScanMode === 2) {
            setNavigateTo(`/ShipInScanByProduct/${shipment.SHPH_ShipmentID}`);
        }
    };

    // /ShipmentInwardScan/${SHPH_ShipmentID}
    useEffect(() => {
        if (navigateTo) {
            navigate(navigateTo);
        }
    }, [navigate, navigateTo]);

    useEffect(() => {
        const fetchSHIPUserData = async () => {
            try {
                const reqData = await fetch(`${config.API_URL}/Shipment_Pending_Scanning_Inward/${UM_CompanyGrpID}/${UM_CompanyID}/${selectedScpId}`, {
                    method: 'GET',
                });
                if (reqData.ok) {
                    const resData = await reqData.json();
                    const uniqueShipments = removeDuplicates(resData.shipment, 'SHPH_ShipmentID');
                    setUserdata(uniqueShipments);
                } else {
                    console.error('Error fetching the shipment list');
                }
            } catch (error) {
                console.log("Failed to fetch data:", error);

            }
        };
        fetchSHIPUserData();
    }, [UM_CompanyGrpID, UM_CompanyID, selectedScpId]);

    const removeDuplicates = (array, key) => {
        return array.reduce((accumulator, current) => {
            if (!accumulator.some(item => item[key] === current[key])) {
                accumulator.push(current);
            }
            return accumulator;
        }, []);
    };
    const handleSearchInputChange = (e) => {
        setSearchQuery(e.target.value);
    };

    const filteredUserData = userData.filter((shipment) =>
        shipment.SHPH_ShipmentCode.toLowerCase().includes(searchQuery.toLowerCase())
    );

    const NavigateToList = () => {
        navigate(`/ShipInScanPendingList/ShipInScanPendingList`);
    };


    return (
        <>
            <div className='main_container'>
                <h4 className='formHeading '>Shipment Inward</h4>
                <div className='row'>
                    <div className='col-md-6'>
                        <div className='mb-3'>
                            <label className='form-label'>Search Shipment</label>
                            <div className='input-group'>
                                <input
                                    type='text'
                                    className='form-input'
                                    value={searchQuery}
                                    onChange={handleSearchInputChange}
                                    placeholder='Search Shipment'
                                />
                            </div>
                        </div>
                    </div>
                    <div className='col-md-6 d-flex align-items-end OutwardListButton'>
                        <button onDoubleClick={NavigateToList} className="inward_btn">Inward List</button>
                    </div>
                </div>
                {searchQuery && (
                    <div className='shipTableContainer'>
                        <table className="shiptableClass">
                            <thead>
                                <tr>
                                    <th>Sr. No.</th>
                                    <th className='nav-tabs'>Shipment Code</th>
                                    <th className='nav-tabs'>Logistic Party</th>
                                    <th className='nav-tabs'>Vehicle Number</th>
                                    <th className='nav-tabs'>Route Name</th>
                                </tr>
                            </thead>
                            <tbody>
                                {filteredUserData.map((shipment, index) => (
                                    <tr key={index} onClick={() => handleRowClick(shipment)}>
                                        <td>{index + 1}</td>
                                        <td>{shipment.SHPH_ShipmentCode}</td>
                                        <td>{shipment.LGCM_Name}</td>
                                        <td>{shipment.LGCVM_VehicleNumber}</td>
                                        <td>{shipment.RUTL_Name}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                )}
            </div>
            <Link to={`/dashboard/ShipmentSelectScanType`} className="back_btn" type="button">BACK</Link>
        </>
    );
}

export default ShipInScanSearch;